"use strict";
/**
 * OpenSearch Project Search Types
 *
 * These types represent the structure of project documents in OpenSearch indices.
 * They match the output of filterProjectForIndex from lambda-utilities
 */
Object.defineProperty(exports, "__esModule", { value: true });
